export const BRAND_NAME = "Dream International Travel and Tours";

export const LOGO_TITLE = "/assets/img/Logo/Logo_Title.png";
export const LOGO_FULL = "/assets/img/Logo/Logo_Full.png";
export const LOGO_FOOTER = "/assets/img/Logo/Logo_Full_noBG.png";
